class Debugger {

  static build(gState, klass) {

    this.debug = {}

    if (gState && (klass == window || klass.isDebug)) {
      for (var m in console)
        if (typeof console[m] == 'function')
          this.debug[m] = console[m].bind(window.console, klass.toString() + ": ")
    } else {
      for (var m in console)
        if (typeof console[m] == 'function')
          this.debug[m] = function () { }
    }
    return this.debug

  }

}
export default Debugger
